module.exports = __webpack_public_path__ + "static/img/y65.31eaaab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y65.jpg
// module id = 5jiP
// module chunks = 1